
<template>
  <a-layout>
    <a-layout-content class="performance-list" :style="{ margin: '24px 16px', padding: '24px', background: '#fff'}">
      <div class="performance-list-header">项目文件</div>
      <div class="performance-list-search performance-list-search-project-statistic">
        <a-select placeholder="项目" v-model="project_sn" :allowClear="true" class="project_sn" v-if="projectSnList.length>0" showSearch :filterOption="selectFilterOption">
          <a-select-option :value="item.key" v-for="(item,index) in projectSnList" :key="index">{{item.val}}</a-select-option>
        </a-select>
        <a-month-picker placeholder="选择年月" :allowClear="false" :format="monthFormat" :disabledDate="disabledDate" v-model="month" @change="onChangeDate">
          <a-icon slot="suffixIcon" :component="'SvgIcDate'" />
        </a-month-picker>
        <a-button type="primary" @click="query">查询</a-button>
        <a-button @click="clear">清空</a-button>
      </div>
      <a-tabs v-model="currentTag" @change="query">
        <a-tab-pane :key="item.id" :tab="item.name" v-for="item in tagList">
          <div class="header">
            <span class="tip">共有{{pagination.total}}个文件</span>
          </div>
          <a-table class="project-table" :rowKey="record => record.project_sn" :columns="columns" :dataSource="dataSource" :pagination="pagination" :loading="loading" :scroll="{y:tableScrollY}" @change="handleTableChange">

            <template slot="operation" slot-scope="text,record">
              <span style="color:#1890ff;cursor:pointer;" @click="download(record)">下载</span>
            </template>
            <template slot="time" slot-scope="text">
            <span> {{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}}</span>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-layout-content>
  </a-layout>
</template>

<script>
import moment from 'moment';
import {
  projectAuthorized,
} from '../../services/TimesheetStatisticalService.js';
import ProjectManageService from '../../services/ProjectManageService';

import SvgIcDate from '../../assets/svg/ic-date-o.svg';

export default {
  components: {
    SvgIcDate
  },
  data() {
    return {
      monthFormat: 'YYYY-MM',
      breadcrumb: [
        {
          label: '项目管理',
          path: ''
        },
        {
          label: '项目文件',
          path: ''
        },
      ],
      project_sn: undefined,
      month: undefined,
      tableScrollY: 400,
      columns: [
        {
          title: '文件名',
          dataIndex: 'fileName',
          key: 'fileName',
        },
        {
          title: '生成时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 200,
          scopedSlots: { customRender: 'time' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      loading: false,
      exportLoading: false,
      visiblePM: false,
      valuePM: 1,
      currentRecord: {},
      projectSnList: [],
      dataSource: [],
      pagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true
      },
      tagList: [],
      currentTag: null,
    };
  },
  computed: {
    paramsObj() {
      return {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        projectId: this.project_sn,
        typeId: this.currentTag,
        month: moment(this.month).format('YYYYMM')
      };
    },
  },
  created() {
    this.tableScrollY = document.documentElement.clientHeight - 320;
    const vm = this;
    window.onresize = function () {
      vm.tableScrollY = document.documentElement.clientHeight - 320;
      const dom1 = document.getElementsByClassName('ant-table-body');
      const dom2 = document.getElementsByClassName('ant-table-body-inner');
      if (dom1) {
        for (let i = 0; i < dom1.length; i++) {
          dom1[i].style.maxHeight = `${vm.tableScrollY}px`;
        }
      }
      if (dom2) {
        for (let i = 0; i < dom2.length; i++) {
          dom2[i].style.maxHeight = `${vm.tableScrollY}px`;
        }
      }
    };
    const default_date = new Date();
    default_date.setMonth(default_date.getMonth() - 1);
    this.default_date = moment(default_date);
    this.month = moment(default_date);
    this.init();
  },
  methods: {
    moment,
    download(record) {
      console.log(record);
      ProjectManageService.getProjectFileUrl({ id: record.id }).then((res) => {
        console.log(res);
        if (res.status === 'success') {
          window.open(res.data, '_blank');
        }
      });
    },
    selectFilterOption(input, option) {
      return option.componentOptions.children[0].text.includes(input);
    },
    disabledDate(current) {
      return (
        current
        && (current > moment().endOf('day') || current < moment('20190501'))
      );
    },
    onChangeDate(date) {
      this.month = moment(date);
    },
    init() {
      ProjectManageService.getProjectOption().then((res) => {
        if (res.status === 'success') {
          this.projectSnList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
      ProjectManageService.getFileTagList().then((res) => {
        if (res.status === 'success') {
          console.log(res.data);
          this.tagList = res.data;
          if (this.tagList.length > 0) {
            this.currentTag = this.tagList[0].id;
            this.fetchData();
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    fetchData() {
      this.loading = true;
      ProjectManageService.getProjectFileList(this.paramsObj).then((res) => {
        if (res.status === 'success') {
          this.dataSource = res.data.list;
          this.pagination.total = res.data.count;
          this.loading = false;
        } else if (res.status === 'failed') {
          this.dataSource = [];
          this.loading = false;
          this.$Message.error(res.message);
        }
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.pagination = pager;
      this.fetchData();
    },
    query() {
      this.pagination.current = 1;
      this.fetchData();
    },
    clear() {
      this.project_sn = undefined;
      const default_date = new Date();
      default_date.setMonth(default_date.getMonth() - 1);
      this.default_date = moment(default_date);
      this.month = moment(default_date);
      this.fetchData();
    },
  }
};
</script>

<style lang="less">
